import React from "react";
import './toast.css';

const Toast = ({ status, text }) => {
  return (
    <div className="toast-background">
      <div
        className={`toast-wrapper ${
          status || "info"
        } flex align-center no-wrap`}
      >
        <h6>{text}</h6>
      </div>
    </div>
  );
};

export default Toast;
